import React, { useCallback, useEffect, useState } from "react";
import {
  Pencil,
  Trash,
  Plus,
  TrashSimple,
  UploadSimple,
  Key,
  Check,
} from "phosphor-react";
import TableWrapper from "components/common/table-wrapper";
import { DEBOUNCE_DELAY, initialMetaForTable } from "constants/common";
import CustomModal from "components/common/modal";
import Addoutreachstafform from "./Addoutreachstafform";
import ChangePasswordForm from "./ChangePasswordForm";
import {
  getOutreachStaffs,
  createOutreachStaffs,
  updateOutreachStaffs,
  deleteOutreachStaffs,
  deleteBulkOutreachStaffs,
  updateOutreachStaffPassword,
} from "containers/outreachstaff/api";
import { getPolicies } from "containers/policies/api";
import { getOutreachLeaders } from "containers/outreachleaders/api";
import {
  formatDate,
  highlightFirstMatch,
  formatDateTimeZone,
  capitalizeName,
  capitalizePlace,
} from "utils/common";
import Tooltip from "components/common/tooltip";
import debounce from "lodash/debounce";
import { sendOutreachStaffConfirmationEmail } from "containers/outreachstaff/api";
import { useLocation } from "react-router-dom";
let timeout;
const COLUMNS = [
  { columnKey: "name", label: "Staff Name", isSortable: true },
  { columnKey: "email", label: "Email", isSortable: true },
  { columnKey: "last_sign_in_at", label: "Last Login", isSortable: false },
  { columnKey: "status", label: "Status", isSortable: true },
  { columnKey: "created_at", label: "Date Created", isSortable: true },
];
const Outreachstaff = ({ onStatusChange }) => {
  const [outreachstaffList, setOutreachstaffList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [meta, setMeta] = useState(initialMetaForTable);
  const [loading, setLoading] = useState(true);
  const [selectedOutreachstaff, setSelectedOutreachstaff] = useState(0);
  const [isOutreachstaffModalVisible, setOutreachstaffModalVisible] = useState(
    false
  );
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });

  const [isPasswordModalVisible, setPasswordModalVisible] = useState(false);
  const [currentOutreachStaffEdit, setcurrentOutreachStaffEdit] = useState("");
  const [outreachleaderList, setOutreachleaderList] = useState([]);
  const [policiesList, setPoliciesList] = useState([]);
  const [refreshPage, setRefreshPage] = useState(false);
  const [policySearch, setPolicySearch] = useState("");
  const [outreachLeaderSearch, setOutreachLeaderSearch] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("Filter");

  const location = useLocation();
  const debounceFn = useCallback((callback, delay) => {
    clearTimeout(timeout);
    timeout = setTimeout(callback, delay);
  }, []);

  const handleSetSearchQuery = (value) => {
    setMeta((prev) => ({ ...prev, search: value }));
    debounceFn(DEBOUNCE_DELAY, handleRefreshPage);
  };

  const handlePageChange = (value) => {
    setMeta((prevMeta) => ({ ...prevMeta, page: value }));
    setLoading(true);
    handleRefreshPage();
  };

  const handleRefreshPage = () => {
    setRefreshPage((pre) => !pre);
  };

  const handleOutreachstaffSubmission = async (
    staff,
    setSubmitting,
    setErrors
  ) => {
    const staffPolicies = staff.policies.map((el) => ({
      id: el.value,
      name: el.label,
    }));

    try {
      if (typeof currentOutreachStaffEdit === "object") {
        const { id } = staff;
        const result = await updateOutreachStaffs(
          { outreach_staff: { ...staff, policies: staffPolicies } },
          id,
          setErrors
        );
        if (result) {
          handleCloseOutreachstaffModal();
          handleRefreshPage();
        }
      } else {
        const result = await createOutreachStaffs(
          {
            outreach_staff: { ...staff, policies: staffPolicies },
          },
          setErrors
        );
        if (result) {
          handleCloseOutreachstaffModal();
          handleRefreshPage();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleClosePasswordModal = () => {
    setcurrentOutreachStaffEdit("");
    setPasswordModalVisible(false);
  };
  const handleChangepasswordSubmission = async (data) => {
    try {
      const { id } = currentOutreachStaffEdit;
      const result = await updateOutreachStaffPassword(
        { outreach_staff: { password: data.password } },
        id
      );
      if (result) {
        handleClosePasswordModal();
        // handleRefreshPage();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleSelectAll = () => {
    const updatedCheckboxes = outreachstaffList.map((checkbox) => ({
      ...checkbox,
      checked: !selectAll,
    }));
    setOutreachstaffList(updatedCheckboxes);
    setSelectAll(!selectAll);
  };

  const handleCheckboxChange = (index) => {
    setOutreachstaffList((prevList) =>
      prevList.map((item, itemIndex) =>
        itemIndex === index ? { ...item, checked: !item.checked } : item
      )
    );
  };

  const handleCloseOutreachstaffModal = () => {
    setOutreachstaffModalVisible(false);
    setcurrentOutreachStaffEdit("");
  };

  const handleOpenOutreachstaffModal = () => {
    setOutreachstaffModalVisible(true);
  };

  const handleDeleteOutreachstaff = async (id) => {
    const result = await deleteOutreachStaffs(id);
    if (result) handleRefreshPage();
  };
  const handleBulkDeleteOutreachstaff = async () => {
    const selectedOutreachStaffIds = outreachstaffList
      ?.filter((staff) => staff.checked)
      .map((staff) => staff.id);
    const payload = {
      ids: selectedOutreachStaffIds,
    };
    const result = await deleteBulkOutreachStaffs(payload);
    if (result) handleRefreshPage();
  };

  const fetchPolicies = useCallback(async () => {
    try {
      const result = await getPolicies({
        ...initialMetaForTable,
        search: policySearch,
      });
      if (result["policies"]) {
        const data = result?.policies;
        setPoliciesList(data);
      }
    } catch (error) {
      console.log(error);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchOutreachStaff = useCallback(
    async (searchString) => {
      setLoading(true);
      try {
        const result = await getOutreachStaffs({
          ...meta,
          filter: "outreach_staff",
          key: sortConfig.key,
          order: sortConfig.direction,
        });
        console.log("outreach staffs are", result);
        if (result["outreach_staffs"]) {
          const data = result?.outreach_staffs.map((item) => ({
            ...item,
            checked: selectAll,
            created_at: item.created_at,
            updated_at: item.updated_at,
          }));
          setOutreachstaffList(data);
          setTotalCount(result?.meta.total_count);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [refreshPage, meta, selectAll, sortConfig.direction, sortConfig.key]
  );

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };
  const SortableTableHeader = ({
    columnKey,
    label,
    sortConfig,
    onSortChange,
  }) => {
    const isSorting = sortConfig.key === columnKey;
    const isAscending = isSorting && sortConfig.direction === "asc";
    const isDescending = isSorting && sortConfig.direction === "desc";

    const handleSort = () => {
      if (isAscending) {
        onSortChange(columnKey, "desc");
      } else {
        onSortChange(columnKey, "asc");
      }
    };

    return (
      <th onClick={handleSort} style={{ cursor: "pointer" }}>
        <div className="d-flex position-relative">
          <div className="d-flex flex-column cursor-pointer me-2 position-absolute top-50  end-100 translate-middle-y ">
            {/* <CaretUp size={12} color={isAscending ? '#000000' : '#00000050'} weight="fill" />
            <CaretDown color={isDescending ? '#000000' : '#00000050'} size={12} weight="fill" /> */}
          </div>
          <div>{label}</div>
        </div>
      </th>
    );
  };

  const debouncedFetchPolicies = useCallback(
    debounce((searchString) => {
      fetchPolicies(searchString);
    }, DEBOUNCE_DELAY),
    []
  );

  useEffect(() => {
    debouncedFetchPolicies(policySearch);
  }, [policySearch]);

  const handlePolicySearch = (searchString) => {
    setPolicySearch(searchString);
  };

  useEffect(() => {
    fetchOutreachStaff();
  }, [fetchOutreachStaff]);

  useEffect(() => {
    setSelectedOutreachstaff(
      selectAll
        ? outreachstaffList.length
        : outreachstaffList.reduce((accumulator, item) => {
            if (item.checked) {
              return accumulator + 1;
            } else return accumulator;
          }, 0)
    );
  }, [outreachstaffList, selectAll]);
  const fetchOutreachLeaders = useCallback(async (searchString) => {
    try {
      const result = await getOutreachLeaders({
        ...initialMetaForTable,
        search: searchString,
        active: true,
      });
      if (result?.outreach_leaders) {
        setOutreachleaderList(result.outreach_leaders);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);
  const debouncedFetchOutreachLeaders = useCallback(
    debounce((searchString) => {
      fetchOutreachLeaders(searchString);
    }, DEBOUNCE_DELAY),
    []
  );
  useEffect(() => {
    debouncedFetchOutreachLeaders(outreachLeaderSearch);
  }, [debouncedFetchOutreachLeaders, outreachLeaderSearch]);
  const handleOutreachLeaderSearch = (searchString) => {
    setOutreachLeaderSearch(searchString);
  };
  const handleFilterSelect = (selectedOption) => {
    setSelectedFilter(selectedOption.label);
    onStatusChange(selectedOption);
  };
  const tableHeaders = [
    { label: "Staff Name", show: location.pathname.includes("/users") },
    { label: "Name", show: !location.pathname.includes("/users") },
    { label: "Email", show: true },
    // { label: "User Type", show: location.pathname.includes("/users") },
    { label: "Username", show: !location.pathname.includes("/users") },
    { label: "Outreach Leader", show: !location.pathname.includes("/users") },
    { label: "Last Login", show: true },
    { label: "Status", show: true },
    { label: "Date Created", show: true },
    { label: "", show: true },
  ];
  return (
    <>
      <TableWrapper
        searchPlaceholder="Search Outreach Staff"
        setSearhQuery={handleSetSearchQuery}
        searchValue={meta.search}
        totalListCount={totalCount}
        pageSize={meta.perPage}
        currentPage={meta.page}
        isLoading={loading}
        onPageChange={handlePageChange}
        selectedItems={selectedOutreachstaff}
        upload={true}
        uploadKey={"OutreachStaff"}
        actionButtons={
          selectedOutreachstaff > 0
            ? [
                {
                  label: `Delete ${selectedOutreachstaff} Items`,
                  classes: "danger-btn m-0-imp",
                  icon: <TrashSimple size={24} className="me-3" />,
                  handleClick: handleBulkDeleteOutreachstaff,
                },
              ]
            : // !location.pathname.includes("/users")
              // ?
              [
                {
                  label: "Add Outreach Staff",
                  classes: "primary-btn",
                  icon: <Plus size={24} className="me-3" />,
                  handleClick: handleOpenOutreachstaffModal,
                },
                {
                  label: "Outreach Staff",
                  handlefilterSelect: handleFilterSelect,
                  dropdown: true,
                  dropdownOptions: [
                    { label: "Outreach Leader", value: "outreach_leader" },
                    {
                      label: "Referral Coordinator",
                      value: "referralcoordinator",
                    },
                  ],
                },
              ]
          // : [
          //     {
          //       label: "Outreach Staff",
          //       handlefilterSelect: handleFilterSelect,
          //       dropdown: true,
          //       dropdownOptions: [
          //         { label: "Outreach Leader", value: "outreach_leader" },
          //         { label: "Referral Coordinator", value: "referrals" },
          //       ],
          //     },
          //   ]
        }
      >
        <div className="container-fluid">
          <div className="table-responsive scrollable">
            <table className="table table-rows">
              <thead className="table-header">
                <tr>
                  <th>
                    <div className="form-check ps-3 mb-0">
                      <input
                        className="form-check-input light-grey-background"
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </div>
                  </th>
                  {COLUMNS.map((column) => (
                    <SortableTableHeader
                      key={column.columnKey}
                      columnKey={column.columnKey}
                      label={column.label}
                      isSortable={column.isSortable}
                      sortConfig={sortConfig}
                      onSortChange={handleSort}
                    />
                  ))}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {outreachstaffList?.map((outreachstaff, index) => (
                  <tr key={index}>
                    <td>
                      <div className="form-check ps-3 mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={outreachstaff.checked}
                          onChange={() => handleCheckboxChange(index)}
                          value=""
                        />
                      </div>
                    </td>
                    <td>
                      {highlightFirstMatch(
                        capitalizeName(outreachstaff.name || ""),
                        meta?.search || ""
                      )}
                    </td>

                    <td>
                      {highlightFirstMatch(outreachstaff.email, meta.search)}
                    </td>

                    {!location.pathname.includes("/users") && (
                      <td>
                        {highlightFirstMatch(
                          outreachstaff.username,
                          meta.search
                        )}
                      </td>
                    )}
                    {/* {location.pathname.includes("/users") && (
                      <td>
                        {highlightFirstMatch(
                          outreachstaff.usertype || "-",
                          meta?.search || ""
                        )}
                      </td>
                    )} */}

                    {!location.pathname.includes("/users") && (
                      <td>
                        {capitalizeName(outreachstaff?.outreach_leader?.name)}
                      </td>
                    )}

                    <td>{outreachstaff.last_sign_in_at}</td>
                    <td>
                      <div
                        className={`status ${
                          outreachstaff.status === "active"
                            ? "active"
                            : "inactive"
                        }`}
                      >
                        {outreachstaff.status.charAt(0).toUpperCase() +
                          outreachstaff.status.slice(1)}
                      </div>
                    </td>
                    <td> {outreachstaff.created_at}</td>
                    <td>
                      <Tooltip title="Edit">
                        <Pencil
                          size={24}
                          className="opacity-50"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setcurrentOutreachStaffEdit({
                              ...outreachstaff,
                              policies: outreachstaff?.policies?.map((el) => ({
                                value: el.id,
                                label: el.name,
                              })),
                            });
                            handleOpenOutreachstaffModal();
                          }}
                        />
                      </Tooltip>{" "}
                      {!location.pathname.includes("/users") &&
                        outreachstaff?.id && (
                          <Tooltip title="Delete">
                            <Trash
                              size={24}
                              className="ms-3 opacity-50"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                outreachstaff?.id &&
                                  handleDeleteOutreachstaff(outreachstaff.id);
                              }}
                            />
                          </Tooltip>
                        )}
                      <Tooltip title="Change Password">
                        <Key
                          size={24}
                          className="ms-3 opacity-50"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setcurrentOutreachStaffEdit({
                              ...outreachstaff,
                              policies: outreachstaff?.policies?.map((el) => ({
                                value: el.id,
                                label: el.name,
                              })),
                            });
                            setPasswordModalVisible(true);
                          }}
                        />
                      </Tooltip>
                      {!outreachstaff.confirmed ? (
                        <Tooltip title="Send Confirmation Email">
                          <UploadSimple
                            size={24}
                            className="ms-3 opacity-50"
                            style={{ cursor: "pointer" }}
                            onClick={async () => {
                              await sendOutreachStaffConfirmationEmail(
                                outreachstaff?.id
                              );
                            }}
                          />
                        </Tooltip>
                      ) : (
                        <Tooltip title="User Confirmed">
                          <Check size={24} className="ms-3 opacity-50" />
                        </Tooltip>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </TableWrapper>
      {isOutreachstaffModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseOutreachstaffModal}
          heading={`${
            currentOutreachStaffEdit ? "Edit" : "Add"
          } Outreach Staff`}
        >
          <Addoutreachstafform
            handleQuestionSubmittion={handleOutreachstaffSubmission}
            handleClose={handleCloseOutreachstaffModal}
            currentOutreachStaffEdit={currentOutreachStaffEdit}
            outreachleaderList={outreachleaderList}
            policiesList={policiesList}
            handlePolicySearch={handlePolicySearch}
            handleOutreachLeaderSearch={handleOutreachLeaderSearch}
            outreachLeaderSearch={outreachLeaderSearch}
          />
        </CustomModal>
      )}
      {isPasswordModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleClosePasswordModal}
          heading={`Change Password`}
        >
          <ChangePasswordForm
            handleSubmit={handleChangepasswordSubmission}
            handleClose={handleClosePasswordModal}
            currentOutreachStaffEdit={currentOutreachStaffEdit}
          />
        </CustomModal>
      )}
    </>
  );
};

export default Outreachstaff;
